$(function () {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/kaannoksen-opas-kiitos/"
    };

    $("#translationChecklistForm").on("submit", function (event) {
        event.preventDefault();
        if ($('#translationChecklistForm')[0].checkValidity() && $('#translationChecklistCheckbox').is(':checked')) {
            $("#translationChecklistSendBtn").prop("disabled", true);
            $("#translationChecklistSendBtn").css("background-color", "#6c757d");

            let email = $("#translationChecklistEmail").val();
            let firstName = $("#translationChecklistFirstName").val();
            let lastName = $("#translationChecklistLastName").val();
            let organization = $("#translationChecklistOrganization").val();
            let selectedOccupation = $("input[name='occupation']:checked").val();
            let code = "";
            if ($('#newsletterCheckbox').is(':checked')) {
                code = "newsletter";
            }

            if (selectedOccupation === "Muulla alalla") {
                selectedOccupation = `${selectedOccupation}: ${$("#occupationOther").val()}`;
            }

            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                organizationName: organization,
                additionalInformation: selectedOccupation,
                competitionName: "Translation guide",
                uri: "/fi/kaannoksen-opas/",
                languageCode: language,
                code: code,
            };


            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function () {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function (err) {
                    console.error(err);
                    $("#translationChecklistSendBtn").prop("disabled", false);
                    $("#translationChecklistSendBtn").css("background-color", "#28a745");
                });
            });
        }
    });

    // Function to toggle button state based on form validity and checkbox
    function toggleSendButtonState() {
        const formValid = $('#translationChecklistForm')[0].checkValidity();
        const checkboxChecked = $('#translationChecklistCheckbox').is(':checked');

        if (formValid && checkboxChecked) {
            // Enable button and change color
            $("#translationChecklistSendBtn").prop("disabled", false);
            $("#translationChecklistSendBtn").css("background-color", "#28a745"); // Change to your desired color (e.g., green)
        } else {
            // Disable button and reset color
            $("#translationChecklistSendBtn").prop("disabled", true);
            $("#translationChecklistSendBtn").css({
                "background-color": "#6c757d", // Change to your disabled color (e.g., grey)
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Trigger the button state change on input and checkbox changes
    $('#translationChecklistForm input, #translationChecklistCheckbox').on('input change', toggleSendButtonState);

    // Initial button state check
    toggleSendButtonState();
});